<template>
    <div id="float-cart">
        <table v-if="loaded" class="table table-sm">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Order code</th>
                    <th scope="col">Price/item</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Total</th>
                    <th v-if="mini === false" scope="col">Note</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items">
                    <td scope="col">
                        <a v-if="summary === false" href="#" @click="removeItem(item)"><i class="fa fa-times"></i></a>
                    </td>
                    <td scope="col"><a :href="'/product/'+item.order_code">{{ item.order_code }}</a></td>
                    <td scope="col">{{ item.price }} €</td>
                    <td scope="col" class="fixed-w">
                        <input v-if="summary === false" min="0" max="100" @change="changeQ(index, $event)" class="form-control" type="number" v-model="items[index].quantity">
                        <span v-if="summary">{{item.quantity}}</span>
                    </td>
                    <td scope="col" class="fixed-w">{{ item.total_price.toFixed(2) }} €</td>

                    <td>
                        <textarea v-if="mini === false && summary === false" v-model="items[index].note" style="width:100%;" v-on:keyup="changeItemNote(index)"></textarea>
                        <span v-if="mini === false && summary === true">{{ items[index].note }}</span>
                    </td>
                </tr>
                <tr v-if="mini === false">
                </tr>
                <!--<tr>
                    <td colspan="2" class="p-3">
                        <label>Discount code:</label>
                        <input v-if="summary === false" v-on:keyup="changeDiscountCode()" class="form-control" type="text" v-model="discountCode">
                        <span v-if="summary">{{discountCode}}</span>
                    </td>
                </tr>-->
                <tr v-if="mini === false">
                </tr>
                <tr>
                    <td :colspan="wideCol-1">
                        <div v-if="summary === false">
                            <a v-if="mini === true" class="btn btn-outline-danger" href="/order">Open cart</a>
                            <a v-if="mini === false" @click="clearCart" class="btn btn-danger" href="#">Clear cart</a>
                            <a v-if="mini === false" class="btn btn-outline-danger" href="/">Continue shopping!</a>
                            <a v-if="mini === false" @click="nextStep" class="btn btn-outline-danger" href="#">Order now!</a>
                        </div>
                    </td>
                    <td :colspan="1" class="text-right">
                        Total:
                    </td>
                    <td colspan="2">
                        {{ totalPrice.toFixed(2) }} €
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    data() {
        return {
            loaded: false,
            totalPrice: 0,
            items: [],
            discountCode: '',
        }
    },
    methods: {
        ...mapActions(['emptyCart', 'addToCart','getCart', 'removeFromCart', 'setItemNote', 'setDiscountCode']),
        ...mapMutations(['UPDATE_CART', 'ITEM_NOTE']),
        removeItem: function(item){
            this.removeFromCart(item);
        },
        changeQ: function(index, e){
            var item = this.items[index];
            item.discount_price = item.price;
            this.addToCart(item);
        },
        changeItemNote: function(index){
            var item = this.items[index];
            item.discount_price = item.price;
            this.setItemNote(item);
        },
        changeDiscountCode: function(){
            this.setDiscountCode(this.discountCode);
        },
        clearCart: function(){
            this.items = [];
            this.emptyCart();
        },
        updateCart: function(){
            this.loaded = false
            this.getCart().then((response) => {
                this.items = response.data.items;
                this.discountCode = response.data.discountCode;
                var total = 0;
                this.items.forEach(function(i) {
                    total+=i.total_price
                })
                this.totalPrice = total
                this.loaded = true
            });
        },
        nextStep: function({ commit }){
            this.$emit('step', 2);
        },
    },
    mounted(){
        this.updateCart();
    },
    computed: {
        ...mapState(['cart']),
        wideCol(){
            if(this.mini === true) {
                return 4;
            } else if(this.summary === true){
                return 4;
            } else
                return 4;
        },
    },
    /*watch: {
        cart: {
            handler(newValue, oldValue) {
                this.updateCart();
            },
            deep: true
        },
    },*/
    props: {
        summary: {
            default: false,
            type: Boolean,
        },
        mini: {
            default: true,
            type: Boolean,
        }
    },
}
</script>
<style scoped>
#float-cart{
    width:100%;
}
td{
    vertical-align: middle !important;
    white-space: nowrap;
}
.fixed-w{
    width: 100px;
}
</style>


